<template>
  <div class="pb-1">
    <div v-if="this.loadpage == false" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <b-card v-if="this.loadpage == true" no-body>
      <b-card-header class="pb-0">
        <div class="pb-1 pb-md-0">
          <b-img
            :src="require('@/assets/telegram/Telegram-logo.webp')"
            fluid
            width="45"
          />
          <span class="h4 pl-1">เชื่อมต่อ Telegram</span>
        </div>
        <b-button variant="outline-info" @click="openModal()">
          <feather-icon icon="LinkIcon"/>
          เชื่อมต่อ Telegram
        </b-button>
      </b-card-header>
      <hr class="pb-0">
      <!-- pc -->
      <b-card-body class="d-none d-sm-block pt-0">
        <!-- <div class="text-right pb-1">
          <a href="https://docs.google.com/document/d/1Kca8CDGR5ivQhZ9LcqAZfwkT4kT1BU5Rovl_I74wY4U/edit?tab=t.0" target="_blank">
            <u>วิธีการเชื่อมต่อ Telegram</u>
          </a>
        </div> -->
        <h4 v-if="this.notifyList.length == 0" class="text-center">ไม่มีการเชื่อมต่อ Telegram</h4>
        <b-table
          v-else
          responsive
          :items="notifyList"
          :fields="notifyFields"
          bordered
          small
          class="position-relative text-nowrap"
        >
        <!-- formatDatetime -->
          <template  #cell(created)="data">
            <div>{{formatDatetime(data.value)}}</div>
          </template>
          <template #cell(checkOrder)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(arrivedChina)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(arrivedThai)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(notifyPayment)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(notifyTracking)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(id)="data">
            <feather-icon
              :id="`delete-icon-${data.value}`"
              icon="TrashIcon"
              class="cursor-pointer text-danger"
              size="20"
              @click="removeTelegram(data.item)"
            />
            <b-tooltip
              title="ลบ"
              :target="`delete-icon-${data.value}`"
              :delay="{show: '1500'}"
            />
          </template>
        </b-table>
      </b-card-body>
      
      <!-- mobile -->
      <div class="text-right pb-1 d-block d-sm-none pr-1">
        <a href="https://docs.google.com/document/d/1Kca8CDGR5ivQhZ9LcqAZfwkT4kT1BU5Rovl_I74wY4U/edit?tab=t.0" target="_blank">
          <u>วิธีการเชื่อมต่อ Telegram</u>
        </a>
      </div>
      <b-card-body v-for="(item, index) in notifyList" :key="index" class="d-block d-sm-none py-0 px-0" role="tablist">
        <b-card-header class="pb-0" header-tag="header" role="tab">
          <b-container class="px-0">
            <div class="h5">{{formatDatetime(item.created)}}</div>
            <div>{{item.chatID}}</div>
            <div class="text-right">
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                class="btn-icon rounded-circle float-right pr-0"
                v-b-toggle="'list-'+index"
              >
                <span class="when-opened">
                  <feather-icon icon="ChevronUpIcon" />
                </span>
                <span class="when-closed">
                  <feather-icon icon="ChevronDownIcon" />
                </span>
              </b-button>
            </div>
          </b-container>
        </b-card-header>
        <b-collapse :id="'list-'+index" accordion="point" role="tabpanel">
          <b-card-body class="py-0">
            <h5 class="pl-1" v-if="item.checkOrder == true">- แจ้งเตือนตรวจออเดอร์เรียบร้อย</h5>
            <h5 class="pl-1"  v-if="item.arrivedChina == true">- แจ้งเตือนสินค้าเข้าโกดังจีน</h5>
            <h5 class="pl-1" v-if="item.arrivedThai == true">- แจ้งเตือนสินค้าเข้าโกดังไทย</h5>
            <h5 class="pl-1" v-if="item.notifyPayment == true">- แจ้งเตือนชำระเงินค่าขนส่ง</h5>
            <h5 class="pl-1" v-if="item.notifyTracking == true">- แจ้งเตือนเลข Tracking ส่งสินค้า</h5>
            <h5 class="text-right">
              <b-button	@click="removeTelegram(item)" class="btn-icon" variant="danger">
                <feather-icon class="icon" icon="Trash2Icon" size="15"/>
              </b-button>
            </h5>
          </b-card-body>
        </b-collapse>
        <hr class="pb-0">
      </b-card-body>
    </b-card>

    <!-- moadal -->
    <b-modal
      id="connect"
      ref="connect"
      scrollable
      hide-footer
      title="เชื่อมต่อ Telegram"
      title-class="h4"
      size="md"
      centered
    >
      <b-form class="pt-2">
        <b-card class="text-center container d-none d-sm-block" style="width:75%">
          <b-img
            :src="require('@/assets/logo-jinmatai/jinmatai-logo.png')"
            fluid
            width="100"
          />
          <feather-icon class="ml-2 mr-1" icon="Link2Icon" size="20"/>
          <b-img
            :src="require('@/assets/telegram/Telegram-logo.webp')"
            fluid
            width="100"
          />
        </b-card>
        <b-card class="text-center container d-block d-sm-none" style="width:75%">
          <b-img
            :src="require('@/assets/logo-jinmatai/jinmatai-logo.png')"
            fluid
            width="100"
          />
          <div class="py-1">
            <feather-icon icon="Link2Icon" size="20"/>
          </div>
          <b-img
            :src="require('@/assets/telegram/Telegram-logo.webp')"
            fluid
            width="100"
          />
        </b-card>
        <div class="pl-5">
          <b-form-checkbox class="pb-1" v-model="checkOrder">แจ้งเตือนตรวจออเดอร์เรียบร้อย</b-form-checkbox>
          <b-form-checkbox class="pb-1" v-model="arrivedChina">แจ้งเตือนสินค้าเข้าโกดังจีน</b-form-checkbox>
          <b-form-checkbox class="pb-1" v-model="arrivedThai">แจ้งเตือนสินค้าเข้าโกดังไทย</b-form-checkbox>
          <b-form-checkbox class="pb-1" v-model="payment">แจ้งเตือนชำระเงินค่าขนส่ง</b-form-checkbox>
          <b-form-checkbox class="pb-1" v-model="tracking">แจ้งเตือนเลข Tracking ส่งสินค้า</b-form-checkbox>
        </div>
        <div class="text-center pt-1">
          <div v-if="telegramBot == ''" class="text-danger">
            ยังไม่ได้ตั้งค่า Telegram Bot ของแบรนด์นี้ กรุณาติดต่อผู้ดูแลระบบ
          </div>
          <div id="telegram-login-button"></div>
        </div>
      </b-form>
    </b-modal>

    <div id="telegram-login-container" style="display:none;"></div>

  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BButton, BImg, BSpinner, BRow, BCol, BModal, BForm, BContainer,
  BFormRadio, BFormRadioGroup, BFormCheckbox, BTable, BCollapse, BTooltip,
  VBModal, VBToggle
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { formatDatetime } from '@/views/global_function.js'
import { getBranchId, getTelegramBot } from '@/branding'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  name: 'Taobao2youTelegramNotify',

  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },

  components: {
    BCard, BCardHeader, BCardBody, BButton, BImg, BSpinner, BRow, BCol, BModal, BForm, BContainer,
    BFormRadio, BFormRadioGroup, BFormCheckbox, BTable, BCollapse, BTooltip,
    VBModal,VBToggle,
   },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      telegramBot: getTelegramBot(),
      branchID: getBranchId(),
      checkOrder: true,
      arrivedChina: true,
      arrivedThai: true,
      payment: true,
      tracking: true,
      sendId: 0,

      notifyList: [],
      notifyFields: [
        {key: 'chatID', label: 'chatID', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'created', label: 'วันที่สร้าง', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'checkOrder', label: 'ตรวจออเดอร์เรียบร้อย', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'arrivedChina', label: 'สินค้าเข้าโกดังจีน', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'arrivedThai', label: 'สินค้าเข้าโกดังไทย', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'notifyPayment', label: 'ชำระเงินค่าขนส่ง', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'notifyTracking', label: 'เลข Tracking ส่งสินค้า', thClass: 'text-center', tdClass: 'text-center'},
        {key: 'id', label : 'ลบ', thClass: 'text-center', tdClass: 'text-center' }
      ],
      loadpage: false,
    };
  },

  async created() {
    await this.getTelegramList()
    this.loadpage = true
  },

  mounted() {
    window.onTelegramAuth = this.onTelegramAuth;

    // โหลด script Telegram widget (แค่ครั้งเดียว)
    if (!document.getElementById('telegram-widget-lib')) {
      const script = document.createElement('script');
      script.id = 'telegram-widget-lib';
      script.src = 'https://telegram.org/js/telegram-widget.js?7';
      document.head.appendChild(script);
    }
  },

  methods: {
    formatDatetime,
    async openModal() {
      await this.$refs['connect'].show();

      // ล้าง widget เก่าถ้ามี
      const container = document.getElementById('telegram-login-button');
      container.innerHTML = '';

      // ยังไม่ได้ตั้งค่าบอทของแบรนด์นี้ => ไม่ต้องสร้าง widget
      if (this.telegramBot == '') return;

      // สร้าง widget ใหม่ทุกครั้ง
      const widget = document.createElement('script');
      widget.src = 'https://telegram.org/js/telegram-widget.js?7';
      widget.setAttribute('data-telegram-login', this.telegramBot);
      widget.setAttribute('data-size', 'large');
      widget.setAttribute('data-userpic', 'false');
      widget.setAttribute('data-onauth', 'onTelegramAuth(user)');
      widget.setAttribute('data-request-access', 'write');

      container.appendChild(widget);

    },
    closeModal() {
      this.$refs['connect'].hide()
      this.checkOrder = true
      this.arrivedChina = true
      this.arrivedThai = true
      this.payment = true
      this.tracking = true
      this.sendId = 0
    },
    async getTelegramList() {
      let response = await axios.post(
        taobaoService_dotnet + 'LineNotify/get-telegram-list',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
        },
        { headers: header_token }
      );
      this.notifyList = response.data
    },
    async onTelegramAuth(user) {
      let response = await axios.post(
        taobaoService_dotnet + 'LineNotify/auth-telegram',
        {
          "chatID": user.id.toString(),
          "loginToken": this.userData.data.customerInfo.loginToken,
          "branchID": this.branchID,
          "notifyTracking": this.tracking,
          "arrivedThai": this.arrivedThai,
          "arrivedChina": this.arrivedChina,
          "checkOrder": this.checkOrder,
          "notifyPayment": this.payment
        },
        { headers: header_token }
      );
      if (response.data == "success") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'เชื่อมต่อเรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.getTelegramList()
        this.closeModal()
      }
    },
    async removeTelegram(item) {
      this.$swal({
        title: 'ยกเลิกรับการแจ้งเตือน ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการยกเลิกรับการแจ้งเตือนทาง Telegram Notify?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'LineNotify/remove-telegram-notify',
            {
              "notifyID": item.id,
              "loginToken": this.userData.data.customerInfo.loginToken,
            },
            { headers: header_token }
          );
          if (response.data == "success") {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'ยกเลิกรับการแจ้งเตือนเรียบร้อย',
                variant: 'success',
              },
            },
            { position: 'top-center' })
            this.getTelegramList()
          }
        }
      })
    },
  },
};
</script>

<style scoped>
</style>